export default {
	visibilityOptions: ["Public", "Private"],
	visibility: "Public",
	showPricelist: false
};
